import { render, staticRenderFns } from "./presupuestoInterno.vue?vue&type=template&id=a8e67278&"
import script from "./presupuestoInterno.vue?vue&type=script&lang=js&"
export * from "./presupuestoInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports